var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return (_vm.images && _vm.images.length > 0) ||
    (_vm.texts && _vm.texts.length > 0) ||
    _vm.$ceres.isShopBuilder
    ? _c("div", { staticClass: "gpsr-safety-info" }, [
        _c("div", {
          staticClass: "gpsr-title",
          domProps: {
            textContent: _vm._s(
              _vm.$translate("GPSR::Template.safetyInfoTitle")
            )
          }
        }),
        _vm._v(" "),
        _vm.images && _vm.images.length > 0
          ? _c(
              "div",
              { staticClass: "images" },
              _vm._l(_vm.images, function(image, imageIndex) {
                return _c("lazy-img", {
                  key: "image-" + imageIndex,
                  attrs: {
                    "image-url": image,
                    alt: _vm.currentVariation.name,
                    title: _vm.currentVariation.name
                  }
                })
              }),
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.texts && _vm.texts.length > 0
          ? _c(
              "div",
              { staticClass: "texts" },
              _vm._l(_vm.texts, function(text, textIndex) {
                return _c("div", {
                  key: "text-" + textIndex,
                  staticClass: "text-item",
                  domProps: { innerHTML: _vm._s(text) }
                })
              }),
              0
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }